import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Handles field form submission and validation
export default class extends Controller {
  static targets = ["submitButton"]
  static values = {
    resource: String
  }

  connect() {
    logger.log("Field form controller connected")
  }

  onTypeChange(event) {
    // When field type changes, update available validation types
    const fieldType = event.target.value
    const validationBuilderEl = this.element.querySelector('[data-controller*="validation-builder"]')
    
    if (validationBuilderEl) {
      const validationBuilder = this.application.getControllerForElementAndIdentifier(
        validationBuilderEl,
        "validation-builder"
      )
      
      if (validationBuilder) {
        validationBuilder.updateFieldType(fieldType)
      }
    }
  }

  submit(event) {
    // Collect user-defined validations first
    const validationBuilderEl = this.element.querySelector('[data-controller*="validation-builder"]')
    
    if (validationBuilderEl) {
      const validationBuilder = this.application.getControllerForElementAndIdentifier(
        validationBuilderEl,
        "validation-builder"
      )
      
      if (validationBuilder) {
        // Force collection of validations before form submits
        validationBuilder.collectValidations()
        logger.log('User validations collected:', validationBuilder.validationsInputTarget.value)
      }
    }
    
    // Handle SelectField options - this must come AFTER collecting user validations
    // so that select_options are merged into the validations array
    const fieldType = this.element.querySelector('[name*="[type]"]')?.value
    if (fieldType === 'DataField::SelectField') {
      this.collectSelectOptions()
    }
  }

  collectSelectOptions() {
    // Find fields by name pattern (SimpleForm uses STI class names)
    const optionsTextarea = this.element.querySelector('textarea[name*="[options_list]"]')
    const allowMultipleCheckbox = this.element.querySelector('input[name*="[allow_multiple]"]')
    const validationsInput = this.element.querySelector('[data-validation-builder-target="validationsInput"]')
    
    if (!optionsTextarea || !validationsInput) {
      logger.log('Select options collection skipped: missing textarea or validations input')
      return
    }
    
    // Parse options from textarea (one per line, ignore empty lines)
    const optionsText = optionsTextarea.value || ''
    const options = optionsText
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
    
    // Get existing validations (from user-defined validation rules)
    let validations = []
    try {
      validations = JSON.parse(validationsInput.value || '[]')
      logger.log('Existing user validations before merging select options:', validations)
    } catch (e) {
      logger.error('Failed to parse existing validations:', e)
      validations = []
    }
    
    // Remove any old select_options and allow_multiple entries (shouldn't exist after our fix, but safety check)
    const filteredValidations = validations.filter(v => 
      v.type !== 'select_options' && v.type !== 'allow_multiple'
    )
    
    if (filteredValidations.length !== validations.length) {
      logger.warn('Found and removed internal validation types that should have been filtered out')
    }
    
    // Add new select_options if options are defined
    if (options.length > 0) {
      filteredValidations.push({
        type: 'select_options',
        options: options,
        allow_multiple: allowMultipleCheckbox?.checked || false
      })
    }
    
    // Update hidden input with merged validations
    validationsInput.value = JSON.stringify(filteredValidations)
    logger.log('Final validations with select options:', filteredValidations)
  }
}
